import { render, staticRenderFns } from "./SidebarItemDropdown.vue?vue&type=template&id=a6d9b664&scoped=true"
import script from "./SidebarItemDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarItemDropdown.vue?vue&type=style&index=0&id=a6d9b664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d9b664",
  null
  
)

export default component.exports